import { useForm } from "react-hook-form";
import { AddVendedorForm } from "../../EmpresaComponents/CreateForm/AddVendedorForm";
import { useState } from "react";
import { VendedorInfo } from "../../EmpresaComponents/EditarDealForm";
import { VisitaRegister } from "../../../types/empresa";
import { SaveButton } from "../../ui/SaveButton";
import { CancelButton } from "../../ui/CancelButton";
import { useGetTurnosQuery } from "../../../api/filter/dataFilterApi";
import { ErrorMessage } from "../../UtilitiesComponents/ErrorMessage";
import { CircularProgress } from "@mui/joy";
import { ActionButtons } from "src/components/ui/ActionButtons";

interface Props {
    onAddVisit?: (data: VisitaRegister) => void;
    onCancel?: () => void;
    minAvailableDate?: string;
    maxAvailableDate?: string;
    errorMessage?: string | null;
    isLoading?: boolean;
}

export function RegisterVisitaForm({ onAddVisit, onCancel, minAvailableDate, maxAvailableDate, errorMessage, isLoading }: Props) {
    const { data: turnos } = useGetTurnosQuery();

    const [vendedoresAgregados, setVendedoresAgregados] = useState<VendedorInfo[]>([])

    const { 
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<VisitaRegister>();

    const handleAddVisita = handleSubmit(async (data) => {
        if(!onAddVisit) return;

        data.vendedoresAsignados = vendedoresAgregados.map((vendedor) => vendedor.vendedorId);
        onAddVisit(data);
    })

    return (
        <div className="flex flex-col h-full overflow-auto">

            <div className="mt-2 flex-1 flex flex-col overflow-hidden">
                <p className="text-lg font-semibold">Nueva visita</p>

                <div className="flex gap-x-3 justify-between">
                    <div>
                        <label className="text-sm font-semibold">Fecha</label>
                        <input 
                            {...register("fecha", {
                                required: "La fecha de la visita es requerida",
                            })}
                            min={minAvailableDate}
                            max={maxAvailableDate}
                            aria-invalid={errors.fecha ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm"
                            type="date" />

                        {errors.fecha?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.fecha?.message}</p>
                        )}
                    </div>


                    <div>
                        <label className="text-sm font-semibold">Hora de inicio</label>
                        <input
                            {...register("horaInicio", {
                                required: "La hora de inicio es requerida",
                                validate: {
                                    horaInicioIsBeforeFin: (horaInicio, formValues) => {
                                        if(formValues.horaFin === undefined ||
                                            formValues.horaFin < horaInicio)
                                            return false;

                                        return true;
                                    }
                                },
                            })}
                            type="time"
                            aria-invalid={errors.horaInicio ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm"/>

                        {errors.horaInicio?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.horaInicio?.message}</p>
                        )}
                        {errors.horaInicio?.type === "horaInicioIsBeforeFin" && (
                            <p className="valErrorText text-sm">La hora de inicio no puede ser mayor a la de fin</p>
                        )}

                    </div>

                    <div>
                        <label className="text-sm font-semibold">Hora de fin</label>
                        <input
                            {...register("horaFin", {
                                required: "La hora de fin es requerida", 
                                validate: {
                                    horaFinIsAfterInicio: (horaFin, formValues) => {
                                        if(formValues.horaInicio === undefined ||
                                            horaFin < formValues.horaInicio)
                                            return false;

                                        return true;
                                    }
                                }
                            })}
                            type="time"
                            aria-invalid={errors.horaFin ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm"/>

                        {errors.horaFin?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.horaFin?.message}</p>
                        )}
                        {errors.horaFin?.type === "horaFinIsAfterInicio" && (
                            <p className="valErrorText text-sm">La hora de fin no puede ser antes que la de inicio</p>
                        )}

                    </div>
                </div>

                <div className="grid grid-cols-1 gap-x-2">
                    <div>
                        <label className="text-sm font-semibold">Turno</label>
                        <select
                            {...register("turno", {
                                min: 1
                            })}
                            aria-invalid={errors.turno ? "true" : "false"}
                            className="
                                w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                                font-semibold text-gray-600 text-sm">
                            <option value={0} hidden>Seleccionar</option>
                            {turnos?.map((turno, index) => (
                            <option value={turno.id} key={index}>{turno.nombre}</option>
                            ))}
                        </select>
                        {errors.turno?.type === "min" && (
                            <p className="valErrorText text-sm">{"El turno es requerido"}</p>
                        )}
                    </div>
                </div>

                <div className="overflow-hidden">
                    <AddVendedorForm 
                        setVendedoresAgregados={setVendedoresAgregados}
                        vendedoresAgregados={vendedoresAgregados}
                        dealId={0} />
                </div>
            </div>

            {errorMessage && (
                <div className="my-3">
                    <ErrorMessage>
                        {errorMessage}
                    </ErrorMessage>
                </div>
            )}

            <ActionButtons 
                isLoading={isLoading ?? false}
                saveButtonText="Agregar visita"
                saveButtonType="button"
                onSave={() => handleAddVisita()}
                onCancel={onCancel}/>
        </div>
    );
}